import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

export const CalendarContainer = styled(Box)(() => ({
	width: '100%',
}));

/** Six week rows, including the day and the week margin MUI already applies. */
const SIX_WEEK_GRID_HEIGHT = (36 + 4) * 6;

export const DayCell = styled('span')({
	position: 'relative',
	display: 'flex',
	flex: '1 1 0',
	minWidth: 0,
	margin: 0,
	justifyContent: 'center',
	alignItems: 'center',
	lineHeight: 0,
});

export const StyledDateCalendar = styled(DateCalendar)(({ theme }) => ({
	width: '100%',
	maxWidth: '100%',
	height: 'auto',
	maxHeight: 'none',
	overflow: 'visible',
	'& .MuiPickersCalendarHeader-root': {
		paddingLeft: 0,
		paddingRight: 0,
	},
	'& .MuiDayCalendar-root, & .MuiDayCalendar-header, & .MuiDayCalendar-slideTransition, & .MuiDayCalendar-monthContainer':
		{
			width: '100%',
		},
	'& .MuiDayCalendar-header, & .MuiDayCalendar-weekContainer': {
		display: 'flex',
		justifyContent: 'flex-start',
		padding: 0,
	},
	'& .MuiDayCalendar-slideTransition': {
		overflow: 'hidden',
		minHeight: SIX_WEEK_GRID_HEIGHT,
	},
	'& .MuiDayCalendar-weekDayLabel': {
		flex: '1 1 0',
		width: 'auto',
		maxWidth: 'none',
		minWidth: 0,
		margin: 0,
		fontSize: '12px',
		fontWeight: 600,
		color: theme.palette.text.disabled,
	},
	'& .MuiPickersDay-root': {
		fontSize: '14px',
		width: 36,
		height: 36,
		minWidth: 36,
		maxWidth: 36,
		flex: 'none',
		margin: 0,
		padding: 0,
		borderRadius: '50%',
		cursor: 'default',
		pointerEvents: 'none',
	},
	'& .MuiPickersDay-root.Mui-selected': {
		width: 36,
		height: 36,
		borderRadius: '50%',
	},
}));

export const MonthYearHeaderRoot = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: theme.spacing(1, 0, 0.5),
}));

export const MonthYearButton = styled(Button)(({ theme }) => ({
	textTransform: 'none',
	fontWeight: 600,
	fontSize: '0.95rem',
	color: theme.palette.text.primary,
	paddingLeft: theme.spacing(1),
	paddingRight: theme.spacing(0.5),
	minWidth: 0,
}));

export const MonthYearPanel = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	padding: theme.spacing(1),
	minWidth: 220,
}));

export const MonthYearRow = styled('div')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
});

export const MonthYearValue = styled('span')(({ theme }) => ({
	flex: 1,
	textAlign: 'center',
	fontWeight: 600,
	textTransform: 'capitalize',
	color: theme.palette.text.primary,
}));

export const TooltipContent = styled(Box)(() => ({
	padding: '4px',
}));

export const EventItem = styled(Box)<{ isLast?: boolean }>(({ isLast }) => ({
	marginBottom: isLast ? 0 : '4px',
}));

export const EventDescription = styled(Box)(() => ({
	fontSize: '0.85em',
	opacity: 0.9,
}));

export const EventIndicatorsContainer = styled(Box)(() => ({
	position: 'absolute',
	bottom: '2px',
	left: '50%',
	transform: 'translateX(-50%)',
	display: 'flex',
	gap: '2px',
	alignItems: 'center',
	pointerEvents: 'none',
}));

export const EventDot = styled(Box)<{ dotColor: string }>(({ dotColor }) => ({
	width: '4px',
	height: '4px',
	borderRadius: '50%',
	backgroundColor: dotColor,
}));

export const EventOverflow = styled(Box)<{ overflowColor: string }>(
	({ overflowColor }) => ({
		fontSize: '8px',
		fontWeight: 600,
		color: overflowColor,
		marginLeft: '1px',
	})
);

